import React from 'react';
import { Typography } from 'antd';
import { useSidebarContext } from './SidebarContext';
import { useTheme } from '../../../contexts/ThemeContext';
import { getThemedStyles } from './styles';

const { Text } = Typography;

/**
 * 侧边栏底部组件
 * 显示版本信息
 */
const SidebarFooter = () => {
  const { collapsed } = useSidebarContext();
  const { isDark } = useTheme();
  const themedStyles = getThemedStyles(isDark);
  
  if (collapsed) return null;
  
  return (
    <div style={themedStyles.footerStyle}>
      <Text type="secondary" style={{ fontSize: 12 }}>
        v0.1.0
      </Text>
    </div>
  );
};

export default SidebarFooter;
